import { render, staticRenderFns } from "./ResponseHubOwnerRights.vue?vue&type=template&id=77d3cb9e"
import script from "./ResponseHubOwnerRights.vue?vue&type=script&lang=js"
export * from "./ResponseHubOwnerRights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports